export default __webpack_public_path__ + "images/0fda75fc8946724cc50de481051d5d65.webp";